import styled from "styled-components";
import {StyledModal} from "../../../common/shared/modal.styled";
import { colors } from "../../../common/ui/globalColors";

export const FilteringModalStyled = styled(StyledModal)`
  .modal-dialog {
    width: 660px;
    max-width: 660px;
  }
  
  .modal-header {
    display: flex;
    padding: 15px 20px;
    border: none;
    .modal-title {
      flex: 1 1 1px;
      font-family: var(--bllink-font-primary);
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      text-align: center;      
      .building-address {
        color: ${colors.primaryColors.bllinkBlue};
        margin-inline-start: .5em;
      }      
    }
    button {
      flex: 0 0 16px;
      width: 16px;
      height: 16px;
      border: none;
      line-height: 0;
      background-color: transparent;
      cursor: pointer;
      padding: 0;
      color: ${colors.textColors.black};
    }

  }
  
  .modal-footer {
    border: none;
    padding: 42px;
  }
`;
